import { render } from "./HistoryItem.vue?vue&type=template&id=6cb0eb12&scoped=true"
import script from "./HistoryItem.vue?vue&type=script&lang=js"
export * from "./HistoryItem.vue?vue&type=script&lang=js"

import "./HistoryItem.vue?vue&type=style&index=0&id=6cb0eb12&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb0eb12"]])

export default __exports__